/* global axios */
import ApiClient from './ApiClient';

class DriveAPI extends ApiClient {
  constructor() {
    super('drive_files', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(formData) {
    // Ne pas définir Content-Type manuellement pour FormData, le navigateur le fait automatiquement avec la boundary
    return axios.post(this.url, formData);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`);
  }

  generateShareLink(id) {
    return axios.post(`${this.url}/${id}/generate_share_link`);
  }

  disableShareLink(id) {
    return axios.post(`${this.url}/${id}/disable_share_link`);
  }
}

export default new DriveAPI();
